import routes from './routes';
import { SetRoutes } from 'components';

const InvoicesCategoryTicketsPages = () => {
  return (
    <>
      <SetRoutes routes={routes} />
    </>
  );
};

export default InvoicesCategoryTicketsPages;
